import { render, staticRenderFns } from "./CollectionAccordion.vue?vue&type=template&id=48302f6e&scoped=true&"
import script from "./CollectionAccordion.vue?vue&type=script&lang=js&"
export * from "./CollectionAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAccordion.vue?vue&type=style&index=0&id=48302f6e&prod&scoped=true&lang=css&"
import style1 from "./CollectionAccordion.vue?vue&type=style&index=1&id=48302f6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48302f6e",
  null
  
)

export default component.exports